<template>
  <div>
    <div class="d-flex justify-center">
      <v-card
        outlined
        class="elevation-0 rounded-lg"
        style="max-width: 300px"
        v-if="party && cart"
        id="form-sell-user"
      >
        <v-card-text class="d-flex flex-column align-center gap-5 pa-4">
          <v-avatar size="50">
            <v-icon x-large>mdi-account-question</v-icon>
          </v-avatar>
          <div>
            <phone-input
              :phone="user.phone"
              @update:phone="(e) => (user.phone = e)"
              :ddi="user.ddi"
              @update:ddi="(e) => (user.ddi = e)"
              @valid="(v) => (valid = v)"
              dense
              outlined
              label="WhatsApp do Comprador"
              :disabled="loading"
            />
            <v-btn
              :disabled="!valid || loading"
              @click="getUserInfo"
              color="primary"
              :loading="loading"
              block
            >
              Próximo
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <v-alert
      v-if="error"
      border="left"
      class="text-left mt-2 mx-4"
      text
      icon="mdi-alert-circle-outline"
      type="error"
    >
      {{ error }}
    </v-alert>

    <div style="width: 100%; display: flex" class="mt-2">
      <v-btn text @click="$emit('prev')" :disabled="loading" small>
        <v-icon>mdi-chevron-left</v-icon>
        voltar
      </v-btn>
      <v-spacer />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PhoneInput from "../../../../components/global/PhoneInput.vue";
import TICKET from "@/services/admin/ticket";

export default {
  emit: ["input"],
  components: { PhoneInput },
  data: () => ({
    valid: false,
    loading: false,
    error: null,
    user: { phone: "", ddi: 55 },
  }),
  methods: {
    async getUserInfo() {
      try {
        this.loading = true;
        this.error = null;
        const { user, cart, ticketBlockMembership } = await TICKET.sellVerify(
          this.selectedOrganization.id,
          this.party.id,
          {
            cart: this.cart,
            user: {
              phone: this.user.phone,
              ddi: this.user.ddi,
            },
          }
        );
        const formattedCart = await this.formatCartMembership(
          this.cart,
          ticketBlockMembership
        );
        this.$emit("input", user);
        this.$emit("onCartChange", formattedCart);
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    async formatCartMembership(cart, ticketBlockMembership) {
      return Object.fromEntries(
        Object.entries(cart).map(([key, item]) => {
          const canUseMembership = item.ticketBlock.TicketBlockMembership.some(
            (membership) =>
              membership?.membershipId === ticketBlockMembership?.membershipId
          );
          return [
            key,
            {
              ...item,
              ticketBlock: {
                ...item.ticketBlock,
                canUseMembership,
                membershipPrice: item.ticketBlock.TicketBlockMembership?.reduce(
                  (acc, membership) => {
                    if (
                      membership?.membershipId ===
                      ticketBlockMembership?.membershipId
                    )
                      acc.push({
                        ...membership,
                        canUse: true,
                        alreadyUsed: false,
                        Membership: ticketBlockMembership.Membership,
                      });

                    return acc;
                  },
                  []
                ),
              },
            },
          ];
        })
      );
    },
    reset() {
      this.user = { phone: "", ddi: 55 };
      this.error = null;
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
  },
  watch: {},
  props: {
    value: {
      type: Object | null,
    },
    party: {
      type: Object,
      default: () => null,
    },
    cart: {
      type: Array | Object,
      default: () => null,
    },
  },
  mounted() {
    this.$root.$on("sell-reset", this.reset);
  },
};
</script>

<style></style>
